import {
  closeConnectWindow,
  openConnectWindow,
} from "@/features/integrations/connectPopup";
import { confirmConnectionUsable } from "@/features/integrations/confirmConnectionUsable";
import { pollConnection } from "@/features/integrations/pollConnection";
import { startAccessReviewConnection } from "@/services/integrations/accessReviews";
import { getActiveWorkspaceId } from "@/store/workspaceStore";

export async function connectReviewedIntegration(
  assistantMessageId,
  reviewId,
  toolkitSlug,
  { reconnect = false } = {},
) {
  const workspaceId = getActiveWorkspaceId();
  if (!workspaceId) throw new Error("Select a workspace before connecting an app.");
  const popup = openConnectWindow();
  if (!popup)
    throw new Error("Your browser blocked the secure connection window.");
  try {
    const started = await startAccessReviewConnection(
      assistantMessageId,
      reviewId,
      toolkitSlug,
      { reconnect, workspaceId },
    );
    if (started.status === "ACTIVE") {
      closeConnectWindow(popup);
      return started;
    }
    if (popup.closed || !started.redirect_url || !started.connection_id) {
      throw new Error(
        "The connection window closed before consent could begin.",
      );
    }
    popup.location.href = started.redirect_url;
    const settled = await pollConnection({
      connectionId: started.connection_id,
      workspaceId,
    });
    return await confirmConnectionUsable(settled, started.connection_id, workspaceId);
  } catch (error) {
    closeConnectWindow(popup);
    throw error;
  }
}
